<template>
  <div class="header">
    <div class="header-inner">
      <div class="left">
        <!-- logo -->
        <h1><img src="@/assets/images/logo.png"/></h1>
        <!-- city -->
        <div class="city-wrap" >
          <div class="city-selected">
            <div class="city-name">{{name}}<span class="caret"></span></div>
          </div>
          <div class="city-list" v-if="cityListClose==false">
            <div class="hot-wrap">
              <span class="hot-title">热门城市：</span>
              <ul class="hot-list">
                <li class="hot-item" v-for="(item, index) in hotCityList" :key="index" @click="confirmCity(item.cityId,item.name)">{{item.name}}</li>
              </ul>
            </div>
            <ul class="all-wrap">
              <li class="all-list" v-for="(item, idx1) in allCityList" :key="idx1">
                <span class="letter">{{item.start}}</span>
                <div class="list">
                  <div class="item" v-for="(cityList, idx2) in item.cityList" :key="idx2" @click="confirmCity(cityList.cityId,cityList.name)">{{cityList.name}}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- nav -->
        <div class="nav">
          <ul class="navbar">
            <li><a :class="['link', message=='0'?'active':'']" href="https://www.kangou.cn/">首页</a></li>
            <li><router-link :class="['link', message=='1'?'active':'']" to="/filmList">影片</router-link></li>
            <li><router-link :class="['link', message=='2'?'active':'']" to="/cinemaList">影院</router-link></li>
          </ul>
        </div>
      </div>
      <div class="right">
        <!-- user -->
        <div class="user-info">
          <div class="user-avatar">
            <img src="@/assets/images/user.png">
            <span class="caret"></span>
            <ul class="user-menu">
              <li @click="toOrderList">个人中心</li>
              <li @click="logout">退出登录</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {allCity} from '@/api/cinema'
import {removeToken, removeUserid, removeSessionKey} from '@/utils/auth'

export default {
  name: 'headerBar',
  data () {
    return {
      //外面页面传入的值selected
      message:this.selected,
      // 城市id
      cityId: '',
      // 城市名称
      name: this.cityName,
      // 热门城市
      hotCityList: [],
      // 所有城市
      allCityList: [],
      // 默认正常显示’所有城市‘下拉框
      cityListClose: false,
    }
  },
  props:{
    selected: String,
    // 城市名称
    cityName: String
  },
  watch: {
    'cityName': function(newV, oldV){ // watch监听props里name的变化，然后执行操作
      this.name = newV;
    }
  },
  mounted() {
    //保证this实例已经插入文档
    this.$nextTick(function(){
      if(this.name==''){
        this.name = localStorage.getItem("cityName");
      }
      // 新用户登录后只加载一次所有城市
      // if(localStorage.getItem('cityId')==undefined || localStorage.getItem('cityId')==null || localStorage.getItem('cityId')==''){
        // 热门城市和所有城市
        this.allCity();
      // }
    })
  },
  methods: {
    // 获取热门城市和所有城市
    allCity() {
      let data = {};
      allCity(data).then(response => {
        // 热门城市
        this.hotCityList = response.data.hotCityList;
        // 所有城市
        this.allCityList = response.data.cityAll;
      });
    },
    // 选择切换城市
    confirmCity(cityId, name) {
      localStorage.setItem('cityId', cityId);
      localStorage.setItem('cityName', name);
      this.name = name;
      // 向父组件传值
      this.$emit("getCityId", cityId);
      //不显示’所有城市‘下拉框
      this.cityListClose = true;
      let that = this;
      //一秒后恢复默认显示
      setTimeout(function () {
        that.cityListClose = false;
      }, 500);
      this.$router.push({path: '/cinemaList'});
    },
    // 跳转到我的订单列表
    toOrderList() {
      this.$router.push({path: '/orderList'});
    },
    // 退出
    logout(){
      removeToken();
      removeUserid();
      removeSessionKey();
      // 清空所选城市
      localStorage.removeItem("cityId");
      //首页地址
      let homeUrl = process.env.BASE_API + "/#/";
      //encodeURI
      let bussUrl = encodeURIComponent(homeUrl);
      //登录地址
      location.href = process.env.LOGIN_URL + "/weblogin.html#/?redirect_uri=" + bussUrl;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header{
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  /*min-width: 1200px;*/
  background-color: #fff;
  border-bottom: 1px solid #d8d8d8;
}
.header-inner {
  width: 80%;
  margin: 0 auto;
  height: 80px;
  box-sizing: border-box;
}
.header-inner .left{
  float: left;
  display: flex;
  align-items: center;
}
h1 img{
  display: block;
  width: 186px;
  height: 27px;
}
/*city*/
.city-wrap {
  position: relative;
  margin: 0 8px;
  height: 80px;
  line-height: 1;
  box-sizing: border-box;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
}
/*鼠标移入*/
.city-wrap:hover{
  border-left: 1px solid #d8d8d8;
  border-right: 1px solid #d8d8d8;
}
.city-wrap:hover .city-selected{
  position: relative;
  z-index: 1001;
  border-bottom-width: 1px;
  background: #fff;
}
.city-wrap:hover .caret{
  transform: rotate(180deg);
}
.city-wrap:hover .city-list{
  display: block;
}
.city-selected{
  height: 100%;
  padding: 0 10px;
  border: 1px solid transparent;
  border-width: 0 1px;
  z-index: 101;
  cursor: pointer;
}
.city-name {
  display: inline-block;
  margin-top: 32px;
  color: #333;
}
.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 5px solid #666;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
}
.city-list {
  display: none;
  position: absolute;
  left: -1px;
  top: 80px;
  z-index: 100;
  display: none;
  width: 478px;
  height: 330px;
  text-align: left;
  overflow-y: scroll;
  background-color: #fff;
  border: 1px solid #d8d8d8;
}
.city-list .hot-wrap {
  display: flex;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  line-height: 40px;
  border-bottom: 1px solid #e5e5e5;
}
.hot-title{
  display: inline-block;
  width: 80px;
}
.hot-list{
  flex: 1;
  display: inline-block;
}
.hot-item{
  margin-right: 10px;
  display: inline-block;
  cursor: pointer;
}
.hot-item:hover{
  color: #ef4238;
}
.all-wrap{
  padding-bottom: 20px;
}
.all-list{
  padding-left: 20px;
  padding-right: 20px;
  line-height: 36px;
}
.all-list .letter{
  float: left;
  display: block;
  margin-top: 5px;
  width: 20px;
  line-height: 25px;
  text-align: center;
  /* vertical-align: top; */
  background-color: #eee;
  font-weight: 700;
}
.all-list .list{
  margin-left: 40px;
}
.all-list .item{
  margin-right: 10px;
  display: inline-block;
  cursor: pointer;
}
.all-list .item:hover{
  color: #ef4238;
}
/*nav*/
.header .nav {
  /* float: left; */
  display: inline-block;
  background-color: #fff;
  overflow: hidden;
}
.nav .navbar{
  margin: 0;
  padding: 0;
  list-style: none;
  border: none;
}
.nav .navbar li{
  float: left;
}
.nav .link{
  text-align: center;
  display: inline-block;
  height: 80px;
  line-height: 80px;
  width: 70px;
  font-size: 18px;
}
.nav .link:hover{
  color: #ef4238;
  cursor: pointer;
}
.nav .link.active{
  color: #fff;
  background-color: #ef4238;
}
/*user-info*/
.header-inner .right{
  float: right;
}
.user-info{
  position: relative;
  height: 80px;
  border: 1px solid transparent;
  border-width: 0 1px;
  z-index: 101;
}
.user-info .user-avatar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  width: 56px;
  height: 100%;
}
.user-info .user-avatar img {
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
}
/* .user-info .user-avatar .caret {
} */
.user-info .user-menu {
  display: none;
  position: absolute;
  top: 80px;
  left: -1px;
  z-index: 100;
  border: 1px solid #d8d8d8;
  border-width: 0 1px 1px 1px;
  background-color: #fff;
  font-size: 14px;
  color: #333;
  text-align: right;
  padding: 15px 10px 5px;
  text-align: center;
  box-sizing: border-box;
}
.user-info .user-menu li{
  padding-bottom: 6px;
}
/*鼠标移入*/
.user-info:hover{
  border-left: 1px solid #d8d8d8;
  border-right: 1px solid #d8d8d8;
}
.user-info:hover .user-avatar{
  position: relative;
  z-index: 1001;
  border-bottom-width: 1px;
  background: #fff;
}
.user-info:hover .caret{
  transform: rotate(180deg);
}
.user-info:hover .user-menu{
  display: block;
}
.user-info .user-menu li {
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #999;
  cursor: pointer;
}
.user-info .user-menu li:hover{
  color: #ef4238;
}
</style>



// WEBPACK FOOTER //
// src/components/headerBar.vue